import { IsBoolean, IsNumber, IsString } from "class-validator";
import { Expose } from "class-transformer";

export class FormOfPaymentItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isCredit!: boolean;
  @IsBoolean()
  @Expose()
  isFromSaleDate!: boolean;
  @IsString()
  @Expose()
  currencyCode!: string;
  @IsString()
  @Expose()
  code!: string;
}
